export default String.raw`
.products-page__main-container{
    display: flex;
    gap: 2%;
    margin: 30px 9%;
    justify-content: center;
    &.categories-map-container{
        display: block;
    }
    .left{
        width: 23%;
    }
    .right{
        width: 75%;
    }

    .companies {
        padding: 0;
    }
}

.categories{
    padding: 15px;
    border: 1px solid #D5D5D5;
    border-radius: 8px;
    &__title{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
    }
    &__parent{
        margin: 25px 10px 20px 10px;
        font-size: 14px; 
        line-height: 20px; 
        a{
            color: $primaryColor;
        }
    }
    &__current{
        margin: 20px 10px;
        .name{
            font-weight: 600;
            font-size: 14px; 
            line-height: 20px; 
        }
    }
    &__undercategories{
        .undercategory{
            margin: 20px;
        }
        a .name{
            color: #2E2E2E;
            font-size: 14px; 
            line-height: 20px; 
        }
    } 
    .count{
        color: #767676;
        font-size: 12px;
        line-height: 16px;
    }
}
  
.filters{
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #D5D5D5;
    border-radius: 8px;
    &__title{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        color: #2E2E2E;
        padding-bottom: 15px;
    }
    &__price{
        margin-top: 15px;
        border-top: 1px solid #D5D5D5;
        display: flex;
        flex-direction: column;
        user-select: none;
        -webkit-user-select: none;
        position: relative;
        .title{
            font-weight: 600;
            font-size: 14px; 
            line-height: 20px; 
            margin: 15px 10px;
        }
        .range{
            display: flex;
            align-items: baseline;
            margin: 0 10px;
            margin-bottom: 40px - 24px;
        }
        fieldset {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: $inputsBgColor;
            width: 50%;
            height: calc(40px + 12px);
            border: 1px solid #4A4A4A;
            border-radius: 5px;
            padding-top: 0;
            padding-bottom: 0;
            padding-right: 0;
            span {
                font-size: 12px;
                position: relative;
                bottom: 6px;
            }
            input {
                border: none;
                width: 75%;
                height: 100%;
                font-size: 14px;
                position: relative;
                bottom: 6px;
            }
            legend {
                font-size: 12px;
                color: #4A4A4A;
            }
        }
        span {
            font-size: 12px;
            position: relative;
            bottom: 6px;
            margin: 0 0.5em;
        }
    }
    &__item{
        border-top: 1px solid #D5D5D5;
        transition: height 500ms;

        .toggle-checkbox{
            display: none;

            & + .name + .values {
                visibility: hidden;
            }

            &:checked + .name + .values{
                max-height: 500px;
                margin-bottom: 16px;
                visibility: visible;
            }

            &:checked + .name svg{
                transform: rotate(180deg);
            }
        }
        .name{
            color: #2E2E2E;
            font-weight: 600;
            font-size: 14px; 
            line-height: 20px; 
            margin: 15px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            svg{
                width: 15px;
                height: 15px;
                transition: all ease 500ms;
            }
        }
        label.name{ 
            color: #2E2E2E;
            font-size: 14px;
            height: auto;
            width: auto;
            margin: 15px 10px;
        }
        .values{
            transition: all ease 500ms;
            max-height: 0;
            overflow: hidden;
        }

        &-show-more {
            display: none;

            & ~ label {
                .less {
                    display: none;
                }
            }

            &:checked ~ label {
                .less {
                    display: inline;
                }

                .more {
                    display: none;
                }
            }
        }
    }
    .checkbox{
        padding: 5px 10px;
        input{
            display: none;
            &:checked + label{
                &:before{
                    content: "";
                    text-align: center;
                    background-color: $primaryColor;
                    overflow: hidden;
                    border: solid 1px $primaryColor;
                }
                .checkbox__icon{
                    display: block;
                    position: absolute;
                    left: 2px;
                    margin-top: 2px;
                }
            } 
        }
        label {
            display: flex;
            align-items: center;
            column-gap: 8px;
            cursor: pointer;
            position: relative;
            background-color: rgba(0, 0, 0, 0);
            color: #232323;
            transition: all 200ms ease;
            font-size: 14px; 
            line-height: 20px; 
            &:before{
                content: "";
                display: inline-block;
                width: 16px;
                height: 16px;
                border-radius: 4px;
                border: solid 1px #767676;
                color: #fff;
                background-color: #FFFFFF;
                box-sizing: border-box;
                transition: all 200ms ease;
                min-width: 16px;
                min-height: 16px;
            }
        }
        &__icon{
            display: none;
        }
        &__color{
            width: 18px;
            height: 18px;
            border-radius: 50%;
        }
        svg{
            fill: #FFFFFF;
            width: 12px;
            height: 12px;
        }
        .count{
            color: #767676;
            font-size: 12px;
            line-height: 16px;
        }
    }
    .primary-action-button{
        font-weight: 600;
        font-size: 14px; 
        line-height: 20px !important; 
        padding: 8px 32px;
        width: 100%;
    }
    &__more-btn {
        margin: 8px 10px 4px;
        width: fit-content;
    }

    &__more-filters {
        overflow: hidden;
        max-height: 0;
        transition: max-height 500ms;
    }
}

.selected-filters{
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
    padding-bottom: 25px;
    border-bottom: 1px solid #E7E7E7;
    margin-bottom: 25px;
    &__clear-all{
        cursor: pointer;
        color: $primaryColor;
        font-weight: 600;
        font-size: 14px; 
        line-height: 20px; 
    }
    &__item{
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 5px 5px 5px 10px;
        border: 1px solid #4A4A4A;
        border-radius: 24px;
        cursor: pointer;
        color: #2E2E2E; 
        background-color: #fff; 
        font-size: 14px; 
        svg{
            width: 15px;
            height: 15px;
            fill: #4A4A4A;
        }
    }
}
  
.sorting-and-views{
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    select{
        display: none;
    }
    .select__input{
        min-width: 250px;
        border: 1px solid #4A4A4A;
        border-radius: 5px;
        padding: 7px 15px;
        svg{
            width: 15px;
            height: 15px;
        }
    }
    &__toggle-filters-menu{
        display: none;
    }
    &__views-list{
        display: flex;
        gap: 10px;

        button {
            svg{
                width: 40px;
                height: 40px;
                padding: 9px 7px;
                fill: $inactiveListIconColor;
                cursor: pointer;
            }

            &.active-js{
                svg {
                    fill: $activeListIconColor;
                    background-color: $activeListIconBackgroundColor;
                }
            }
        }
    }
}
  
.quick-shopping-buttons-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 25px 0;
    &__total-items{
        color: #2E2E2E;
        font-size: 14px; 
        line-height: 20px; 
    }
    &__buttons{
        display: flex;
        gap: 25px;
        .login-to-see-prices{
            display: flex;
            align-items: center;
            gap: 10px;
            &__icon{
                width: 19px;
                height: 19px;
            }
            &__info{
                font-size: 14px; 
                line-height: 20px; 
            }
        }
        .primary-action-button{
            width: 230px;
            margin-left: 15px;
            display: inline-flex;
            align-items: center;
            gap: 5px;
            padding: 10px 20px;
            svg{
                width: 20px;
                height: 20px;
            }
        }
        .secondary-action-button{
            width: 40px;
            aspect-ratio: 1;
            padding: 10px 20px;
            svg{
            flex-shrink: 0;
                width: 24px;
                height: 24px;
                fill: $primaryColor;
            }
        }
    }
}

.categories-and-filters-header{
    display: none;
}

.no-items-container{
    display: flex;
    gap: 25px;
    margin-bottom: 25px;
    justify-content: center;
    .title{
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 5px;
    }
    .info{
        color: #767676;
        font-size: 16px;
        line-height: 20px; 
    }
}
`